import { OperatorsEnum } from '../../utils/enum/OperatorsType';

export enum HEADER_TYPE {
    NUMERIC = 'NUMERIC',
    OPEN = 'OPEN',
    CHOICE = 'CHOICE',
    DATE = 'DATE'
}

export interface Header {
    id: string
    label: string
    type: HEADER_TYPE
    rowKey: string
    values?: string[]
    filter?: string[]
    displayFilter: boolean
    filterDate?: FilterDateInterface
}

export interface VirtualizedTableProps {
    rows: any[]
    headers: Header[]
    handleDeleteRow?: (row: any) => void
    handleReloadRow?: (row: any) => void
    handleUpdateRow?: (row: any) => void
}

export interface CreateRowCellInterface {
    currentColumn: Header,
    row: any,
}

export interface FilterDateInterface {
    date: Date | null
    operator: OperatorsEnum | null
}
